import { render, staticRenderFns } from "./ButtonsSet.vue?vue&type=template&id=51605e24&"
import script from "./ButtonsSet.vue?vue&type=script&lang=js&"
export * from "./ButtonsSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports